export const SET_PROPERTY_KEYS = 'SET_PROPERTY_KEYS';
export const SET_PROPERTY_KEYS_LOADING_STATE = 'SET_PROPERTY_KEYS_LOADING_STATE';
export const SET_PROPERTY_KEYS_ERROR_CODE = 'SET_PROPERTY_KEYS_ERROR_CODE';
export const REMOVE_PROPERTY_KEYS = 'REMOVE_PROPERTY_KEYS';
export const SET_PROPERTY_SCHEDULED_KEYS_DATE = 'SET_PROPERTY_SCHEDULED_KEYS_DATE';
export const SET_SCHEDULED_PROPERTY_KEYS_LOADING_STATE = 'SET_SCHEDULED_PROPERTY_KEYS_LOADING_STATE';
